import {Box, Breadcrumbs, Link, Typography} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {useNavigate} from "react-router-dom";
import LayoutContentTitle from "./LayoutContentTitle";
import * as React from "react";
import {observer} from "mobx-react";

function LayoutContentToolbar({title, subtitle, breadcrumbs, children}) {
    const navigate = useNavigate();
    const style = styles();

    const renderBreadcrumbs = () => (
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small"/>} sx={style.breadcrumbs}>
            {breadcrumbs.map((crumb, index) => {
                const isCurrent = index === breadcrumbs.length - 1;
                if (isCurrent) {
                    return <Typography key={crumb.label} sx={style.crumbCurrent}>{crumb.label}</Typography>;
                }
                if (!crumb.path) {
                    return <Typography key={crumb.label} sx={style.crumbMuted}>{crumb.label}</Typography>;
                }
                return (
                    <Link key={crumb.label} component="button" onClick={() => navigate(crumb.path)} sx={style.crumbLink}>
                        {crumb.label}
                    </Link>
                );
            })}
        </Breadcrumbs>
    );

    return (
        <Box sx={style.header}>
            <Box sx={style.titleBlock}>
                {breadcrumbs?.length > 0 && renderBreadcrumbs()}
                <LayoutContentTitle title={title}/>
                {subtitle && <Box sx={style.subtitle}>{subtitle}</Box>}
            </Box>
            {children && <Box sx={style.actions}>{children}</Box>}
        </Box>
    );
}

export default observer(LayoutContentToolbar);

const styles = () => ({
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
        marginBottom: '2rem',
        paddingBottom: '1rem',
        borderBottom: '1px solid',
        borderColor: 'divider',
    },
    titleBlock: {
        display: 'flex',
        flexDirection: 'column',
        gap: 0.25,
    },
    breadcrumbs: {
        fontSize: '0.8rem',
        marginBottom: 0.25,
    },
    crumbLink: {
        fontSize: '0.8rem',
        color: 'text.secondary',
        textDecoration: 'none',
        '&:hover': {color: 'primary.main', textDecoration: 'underline'},
    },
    crumbCurrent: {
        fontSize: '0.8rem',
        color: 'text.primary',
        fontWeight: 500,
    },
    crumbMuted: {
        fontSize: '0.8rem',
        color: 'text.secondary',
    },
    subtitle: {
        color: 'text.secondary',
        fontSize: '0.9rem',
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },
});
